import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  SimpleGrid,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import trophyImage from "../assets/images/ar_trophy.jpeg";

function NewLandingPage() {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const textColor = useColorModeValue("gray.800", "white");

  const tournamentDate = new Date("2026-08-14T10:00:00-04:00");

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = tournamentDate.getTime() - now;

      if (distance < 0) {
        setIsStarted(true);
        clearInterval(timer);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(timer);
  }, [tournamentDate]);

  const CountdownBanner = () => {
    if (isStarted) {
      return (
        <Box
          bg="green.500"
          color="white"
          py={3}
          w="full"
          textAlign="center"
          borderBottom="1px"
          borderColor="green.400"
        >
          <Text fontSize="lg" fontWeight="bold">
            Tournament is over.
          </Text>
        </Box>
      );
    }

    return (
      <Box
        bg="blue.600"
        color="white"
        py={3}
        w="full"
        textAlign="center"
        borderBottom="1px"
        borderColor="blue.500"
      >
        <Flex justify="center" align="center" gap={6} flexWrap="wrap">
          <Text fontSize="sm" fontWeight="medium">
            Tournament Starts In:
          </Text>
          <HStack spacing={4}>
            <HStack spacing={1}>
              <Text fontSize="lg" fontWeight="bold">
                {timeLeft.days}
              </Text>
              <Text fontSize="xs">Days</Text>
            </HStack>
            <Text fontSize="sm">:</Text>
            <HStack spacing={1}>
              <Text fontSize="lg" fontWeight="bold">
                {timeLeft.hours.toString().padStart(2, "0")}
              </Text>
              <Text fontSize="xs">Hours</Text>
            </HStack>
            <Text fontSize="sm">:</Text>
            <HStack spacing={1}>
              <Text fontSize="lg" fontWeight="bold">
                {timeLeft.minutes.toString().padStart(2, "0")}
              </Text>
              <Text fontSize="xs">Min</Text>
            </HStack>
            <Text fontSize="sm">:</Text>
            <HStack spacing={1}>
              <Text fontSize="lg" fontWeight="bold">
                {timeLeft.seconds.toString().padStart(2, "0")}
              </Text>
              <Text fontSize="xs">Sec</Text>
            </HStack>
          </HStack>
          <Text fontSize="xs" opacity={0.9}>
            Friday, August 14, 2026
          </Text>
        </Flex>
      </Box>
    );
  };

  return (
    <>
      <CountdownBanner />
      <Box bg={bgColor} minH="calc(100vh - 64px)">
        <Container maxW="container.xl" py={20}>
          <VStack spacing={8} align="center" textAlign="center">
            <Heading
              as="h1"
              size="2xl"
              color={textColor}
              fontWeight="bold"
              lineHeight="1.2"
            >
              Welcome to AR 2026
            </Heading>

            <Text fontSize="xl" color={textColor} maxW="2xl">
              A two-round golf tournament with 24 of the fellas at Tarandowah
              and Fire Rock Golf Courses.
            </Text>

            <HStack spacing={6} pt={8}>
              <Button
                size="lg"
                colorScheme="blue"
                onClick={() => navigate("/leaderboard")}
              >
                View Leaderboard
              </Button>
              <Button
                size="lg"
                colorScheme="green"
                onClick={() => navigate("/players")}
              >
                Players
              </Button>
            </HStack>
            <HStack spacing={6} pt={1}>
              <Button
                size="lg"
                colorScheme="teal"
                onClick={() => navigate("/golf-pool")}
              >
                Join Pool
              </Button>
              <Button
                size="lg"
                variant="outline"
                colorScheme="white"
                onClick={() => navigate("/2025")}
              >
                View AR 2025
              </Button>
            </HStack>

            <SimpleGrid
              columns={{ base: 1, lg: 2 }}
              spacing={8}
              w="full"
              pt={12}
            >
              <Box>
                <Box borderRadius="xl" overflow="hidden" w="full">
                  <Image
                    src="/courses/tarandowah.jpg"
                    alt="Tarandowah Golf Course"
                    w="full"
                    h="auto"
                    objectFit="cover"
                    objectPosition="top"
                  />
                </Box>
                <Text fontSize="lg" mt={2} fontWeight="medium">
                  Round 1: Tarandowah Golf Course
                </Text>
                <Text fontSize="md" color="gray.500">
                  Friday, August 14, 2026
                </Text>
              </Box>
              <Box>
                <Box borderRadius="xl" overflow="hidden" w="full">
                  <Image
                    src="/courses/firerock.jpg"
                    alt="Fire Rock Golf Course"
                    w="full"
                    h="auto"
                    objectFit="cover"
                    objectPosition="top"
                  />
                </Box>
                <Text fontSize="lg" mt={2} fontWeight="medium">
                  Round 2: Fire Rock Golf Course
                </Text>
                <Text fontSize="md" color="gray.500">
                  Saturday, August 15, 2026
                </Text>
              </Box>
            </SimpleGrid>

            <Box pt={12} w="full" maxW="md">
              <Image
                src={trophyImage}
                alt="AR Invitational Trophy"
                borderRadius="xl"
                w="full"
                h="auto"
                objectFit="contain"
              />
              <Text fontSize="lg" mt={2} fontWeight="medium" textAlign="center">
                The Al DaBoyce Memorial Trophy
              </Text>
            </Box>
          </VStack>
        </Container>
      </Box>
    </>
  );
}

export default NewLandingPage;
